import React, { useEffect, useRef } from 'react';

import { CMSCTA, CMSHTML } from '@swf/cms';
import type { StickyFooter } from '@swf/generated/cms/types/StickyFooter';

import styles from './CMSStickyFooter.scss';

let fHeight: number;

const CMSStickyFooter: React.FC<StickyFooter> = ({ html, cta, display }) => {
  const stickyFooterRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const [footer] = document.getElementsByTagName('footer');

    const checkFooterHeight = () => {
      const stickyFooter = stickyFooterRef.current;

      if (!stickyFooter) {
        window.removeEventListener('resize', checkFooterHeight);
        return;
      }

      stickyFooter.style.height = 'auto';
      const footerStyle = window.getComputedStyle(stickyFooter);
      fHeight = parseInt(footerStyle.height);
      if (window.innerWidth <= 767) {
        fHeight = fHeight + 10;
      }

      stickyFooter.style.height = fHeight + 'px';
    };

    const checkFooterScroll = () => {
      const stickyFooter = stickyFooterRef.current;

      if (!stickyFooter) {
        window.removeEventListener('scroll', checkFooterScroll);
        return;
      }

      const scrollPercent = Math.round(
        (window.scrollY / (document.body.offsetHeight - window.innerHeight)) * 100
      );

      const footerBottom = footer.getBoundingClientRect().top;

      let hide = scrollPercent < 10;

      if (footerBottom <= (window.innerHeight || document.documentElement.clientHeight)) {
        hide = true;
      }

      if (hide) {
        stickyFooter.style.bottom = '-' + fHeight + 'px';
      } else {
        stickyFooter.style.bottom = '0px';
      }
    };

    if (footer) {
      checkFooterHeight();
      checkFooterScroll();

      window.addEventListener('resize', checkFooterHeight);
      window.addEventListener('scroll', checkFooterScroll);
    }

    return () => {
      window.removeEventListener('resize', checkFooterHeight);
      window.removeEventListener('scroll', checkFooterScroll);
    };
  }, []);

  return display ? (
    <div className={styles.stickyFooter} ref={stickyFooterRef}>
      <div className={styles.container}>
        <div className={styles.left}>
          <CMSHTML {...html} />
        </div>
        <div className={styles.right}>
          <CMSCTA {...cta} className={styles.cta} />
        </div>
      </div>
    </div>
  ) : null;
};

export default CMSStickyFooter;
